/**
 * @description 로그 태그용
 * @param {string} tag
 * @param {'log' | 'info' | 'error' | 'warn'} level
 * @return {(...rest: any[]) => void}
 */
export const logWithTag = (
  tag: string,
  level?: 'log' | 'info' | 'error' | 'warn',
): ((...rest: any[]) => void) => {
  const args = `[ ${tag} ]`
  level = level ?? 'log'
  return (...rest: any[]) => {
    if (level === 'log') console.log(args, ...rest)
    else if (level === 'info') console.info(args, ...rest)
    else if (level === 'error') console.error(args, ...rest)
    else if (level === 'warn') console.warn(args, ...rest)
  }
}
